// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___I0SNm","icon":"icon___3pp1j","text":"text___1NhFt","retry":"retry___1pTdq"};